/* @flow weak */
import app from "./app/reducer";
import config from "./config/reducer";
import device from "./device/reducer";
import intl from "./intl/reducer";
import mails from "./mails/reducer";
import offer from "./offer/reducer";
import article from "./article/reducer";
import newsletter from "./newsletter/reducer";
import application from "./application/reducer";
import headerResponsive from "../browser/components/HeaderResponsive/reducer";
import { combineReducers } from "redux";
import { fieldsReducer as fields } from "./lib/redux-fields";

const configureReducer = (initialState: Object) => {
  let reducer = combineReducers({
    app,
    config,
    device,
    fields,
    mails,
    offer,
    article,
    newsletter,
    application,
    intl,
    headerResponsive
  });

  return reducer;
};

export default configureReducer;



/** WEBPACK FOOTER **
 ** ./src/common/configureReducer.js
 **/